import { render, staticRenderFns } from "./CardOrderTicketing.vue?vue&type=template&id=0c46f56a&"
import script from "./CardOrderTicketing.vue?vue&type=script&lang=js&"
export * from "./CardOrderTicketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports